import { useRef, useState } from "react";

interface ChartSwitcherProps {
  leftTitle: string;
  rightTitle: string;
  left: React.ReactNode;
  right: React.ReactNode;
}

export default function ChartSwitcher({ leftTitle, rightTitle, left, right }: ChartSwitcherProps) {
  const [showBar, setShowBar] = useState(false);
  const container = useRef<HTMLDivElement>(null);

  // Basic swipe logic
  let startX: number | null = null;
  function onTouchStart(e: React.TouchEvent) { startX = e.touches[0].clientX; }
  function onTouchMove(e: React.TouchEvent) {
    if (!startX) return;
    const delta = e.touches[0].clientX - startX;
    if (Math.abs(delta) > 50) {
      setShowBar(delta < 0);
      startX = null;
    }
  }
  function onTouchEnd() { startX = null; }

  return (
    <div className="w-full relative select-none">
      <div className="flex justify-center mb-0.5 gap-1 text-xs font-semibold text-muted-foreground">
        <button onClick={()=>setShowBar(false)} aria-pressed={!showBar} className={!showBar ? "text-primary bg-muted px-2 py-1 rounded transition" : "px-2 py-1 transition hover:bg-muted" }>{leftTitle}</button>
        <button onClick={()=>setShowBar(true)} aria-pressed={showBar} className={showBar ? "text-primary bg-muted px-2 py-1 rounded transition" : "px-2 py-1 transition hover:bg-muted" }>{rightTitle}</button>
      </div>
      <div
        ref={container}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div className="w-full mt-1">
          {showBar ? right : left}
        </div>
      </div>
    </div>
  );
}